export class FetchOrgUnits {
  static readonly type = '[Organizational units] Get org units';
}
